function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M98.597 24H31.403A6.402 6.402 0 0 0 25 30.407V84.75a6.402 6.402 0 0 0 6.403 6.408h6.385v9.628c0 2.494 2.717 4.035 4.846 2.754l20.783-12.4h35.18A6.402 6.402 0 0 0 105 84.733V30.407c0-3.532-2.873-6.407-6.403-6.407z",
  fill: "#FFB511"
}), /*#__PURE__*/React.createElement("path", {
  d: "M65 69.363c2.761 0 5 2.158 5 4.819C70 76.842 67.761 79 65 79s-5-2.157-5-4.818c0-2.661 2.239-4.819 5-4.819zM65 34c2.762 0 5 2.157 5 4.818V61.31c0 2.591-2.122 4.72-4.783 4.83l-.217.005c-2.762 0-5-2.157-5-4.818V38.818c0-2.59 2.119-4.701 4.777-4.813L65 34z",
  fill: "#F7F5F0"
}));
function SvgIllusWarning({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 104,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllusWarning);
export default __webpack_public_path__ + "static/media/IllusWarning.de2c3874f1185efb6012c52df62f512f.svg";
export { ForwardRef as ReactComponent };